<template>
  <label class="ux-field-title" v-if="showLabel"
    >{{ label }}
    <span class="ux-required-marker" v-if="required">*</span></label
  >
  <div class="ux-field-description" v-if="showDescription">
    {{ description }}
  </div>

  <template v-if="showList">
    <template v-if="multiValue">
      <draggable class="items" v-if="model && model.length" v-model="model">
        <template #item="{ element, index }">
          <item :key="element._id" :item="element">
            <template #actions>
              <ux-menu group="content-actions" right>
                <template #activator="{ on }">
                  <ux-button size="sm" v-on="on" icon @click.stop.prevent>
                    <ux-icon icon="fa-ellipsis" />
                  </ux-button>
                </template>
                <ux-list>
                  <ux-list-item @click="remove(element)"
                    >Remove {{ elementLabel(element) }}</ux-list-item
                  >
                  <ux-list-item v-if="canEdit(element)" @click="edit(element)">
                    Edit {{ elementLabel(element) }}
                  </ux-list-item>
                  <ux-list-item @click="$actions.open([element])">
                    More Actions
                  </ux-list-item>
                </ux-list>
              </ux-menu>

              <!-- <ux-button
                size="sm"
                v-if="$actions"
                icon
                @click.stop.prevent="$actions.open([element])"
              >
                <ux-icon icon="fa-ellipsis" />
              </ux-button>
              <ux-button
                size="sm"
                v-if="canEdit(element)"
                icon
                @click.stop.prevent="edit(element)"
              >
                <ux-icon icon="fa-pencil" />
              </ux-button>
              <ux-button size="sm" icon @click.stop.prevent="remove(element)">
                <ux-icon icon="fa-times" />
              </ux-button> -->
            </template>
          </item>
        </template>
      </draggable>
    </template>
    <template v-else-if="model">
      <div class="items">
        <item :item="model">
          <template #actions>
            <ux-menu group="content-actions" right>
              <template #activator="{ on }">
                <ux-button size="sm" v-on="on" icon @click.stop.prevent>
                  <ux-icon icon="fa-ellipsis" />
                </ux-button>
              </template>
              <ux-list>
                <ux-list-item @click="create" v-if="canCreate">
                  <flex-row gap center>
                    <flex-cell>Replace with new</flex-cell>
                    <!-- <flex-cell shrink><ux-icon icon="fa-retweet" /></flex-cell> -->
                  </flex-row>
                </ux-list-item>

                <ux-list-item @click="swap(model)">
                  <flex-row gap center>
                    <flex-cell>Swap with existing</flex-cell>
                    <!-- <flex-cell shrink><ux-icon icon="fa-retweet" /></flex-cell> -->
                  </flex-row>
                </ux-list-item>

                <ux-list-item @click="clear">
                  <flex-row gap center>
                    <flex-cell>Remove</flex-cell>
                    <!-- <flex-cell shrink><ux-icon icon="fa-times" /> </flex-cell> -->
                  </flex-row>
                </ux-list-item>

                <ux-list-item v-if="canEdit(model)" @click="edit(model)">
                  <flex-row gap center>
                    <flex-cell>Edit</flex-cell>
                    <!-- <flex-cell shrink><ux-icon icon="fa-pencil" /></flex-cell> -->
                  </flex-row>
                </ux-list-item>

                <ux-list-item @click="$actions.open([model])">
                  <flex-row gap center>
                    <flex-cell>More Actions</flex-cell>
                    <!-- <flex-cell shrink
                      ><ux-icon icon="fa-ellipsis" />
                    </flex-cell> -->
                  </flex-row>
                </ux-list-item>
              </ux-list>
            </ux-menu>
          </template>
        </item>
      </div>
    </template>
  </template>
  <template v-if="multiValue || !model">
    <flex-row center gap v-if="canAdd">
      <flex-cell>
        <content-search
          :type="referenceType"
          v-model="model"
          :multiple="multiValue"
          :placeholder="placeholder"
          :list="false"
        />
      </flex-cell>
      <flex-cell shrink v-if="canBrowse">
        <ux-button @click="open">Browse</ux-button>
      </flex-cell>
      <flex-cell shrink v-if="canCreate">
        <ux-button icon color="primary" @click="create">
          <ux-icon icon="fa-plus" />
        </ux-button>
      </flex-cell>
    </flex-row>
  </template>
</template>
<script>
import Item from "../../content/item.vue";
import InputMixin from "./input-mixin";
import ContentSearch from "./content-search.vue";
import draggable from "vuedraggable/src/vuedraggable";

export default {
  components: {
    Item,
    ContentSearch,
    draggable,
  },
  props: {
    modelValue: {
      type: [Object, Array],
    },
    browse: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [InputMixin],
  async created() {
    await this.$glossary.ensure();
    this.value = this.cleanInput(this.value, true);
    this.dispatch();
  },
  methods: {
    elementLabel(element) {
      var str = element.firstName || element.title || "";
      return str.length < 60 ? str : "";
    },
    async swap() {
      var self = this;
      self.touch();

      var modalOptions = {
        field: self.field,
        model: [self.value],
        maximum: 1,
        browserOptions: {
          columns: self.field.columns,
          select: self.field.select,
          lockFilter: self.field.lockFilter,
        },
      };

      let referenceType = this.referenceType;

      if (!referenceType) {
        await self.$glossary.ensure();
        const choices = self.$glossary.items;
        const sorted = choices.sort(sortFunction);
        const { key: selectedKey } = await self.$sdk.options(
          sorted,
          "Select content type",
          "What type of content are you wanting to select",
        );
        referenceType = selectedKey;
      }

      self.$sdk
        .browse(referenceType, modalOptions)
        .then(function (newSelection) {
          self.model = newSelection[0];
        })
        .catch(function (err) {
          if (err) {
            self.$sdk.error(err);
          }
        });
    },
    async create() {
      const self = this;

      if (!self.$sdk.global?.create) {
        return;
      }

      // If there is a model defined on the field
      let model = self.field.createModel;

      const created = await self.$sdk.global.create(self.field.referenceType, {
        model,
        preselected: !!model,
      });

      // If multiple items were created at once
      if (created.multiple) {
        if (self.multiValue) {
          if (!self.model) {
            self.model = [];
          }

          self.model = [...self.model, ...created.items];
        } else {
          self.model = created.items[0];
        }
      }

      if (created._id) {
        if (self.multiValue) {
          if (!self.model) {
            self.model = [];
          }

          self.model.push(created);
        } else {
          self.model = created;
        }
      }
    },
    clear() {
      this.model = undefined;
      this.touch();
    },
    // remove(index) {
    //     if (this.maximum == 1) {
    //         this.model = null
    //     } else {
    //         this.model.splice(index, 1);
    //     }
    // },
    canEdit(item) {
      var user = this.user;
      if (!user) {
        return false;
      }

      return this.$sdk.access.canEditItem(user, item);
    },
    async edit(item) {
      var result = await this.$sdk.global
        .edit(item, true)
        .catch(function (err) {});

      for (var prop in result) {
        item[prop] = result[prop];
      }
    },
    async open() {
      var self = this;
      self.touch();

      var modalOptions = {
        field: self.field,
        model: self.multiValue ? self.value : [self.value].filter(Boolean),
        maximum: self.field.maximum,
        browserOptions: {
          columns: self.field.columns,
          select: self.field.select,
          lockFilter: self.field.lockFilter,
        },
      };

      let referenceType = this.referenceType;

      if (!referenceType) {
        // Create the choices
        await self.$glossary.ensure();
        const choices = self.$glossary.items;
        const sorted = choices.sort(sortFunction);
        const { key: selectedKey } = await self.$sdk.options(
          sorted,
          "Select content type",
          "What type of content are you wanting to select",
        );
        referenceType = selectedKey;
      }

      switch (referenceType) {
        case "scope":
          const scopeModel = self.multiValue
            ? self.value
            : [self.value].filter(Boolean);

          return self.$sdk
            .selectScopes({
              action: "view",
              type: referenceType,
              model: scopeModel,
              maximum: self.field.maximum,
            })
            .then(function (newSelection) {
              console.log("GOT NEW SELECTION", newSelection);
              self.model = self.multiValue ? newSelection : newSelection[0];
            })
            .catch(function (err) {
              if (err) {
                self.$sdk.error(err);
              }
            });
      }

      self.$sdk
        .browse(referenceType, modalOptions)
        .then(function (newSelection) {
          self.model = self.multiValue ? newSelection : newSelection[0];
        })
        .catch(function (err) {
          if (err) {
            self.$sdk.error(err);
          }
        });
    },
    cleanInput(val) {
      var self = this;
      if (self.multiValue) {
        if (!val) {
          val = [];
        }

        if (!Array.isArray(val)) {
          val = [];
        }

        /////////////////////////////////

        if (self.maximum) {
          if (val.length > self.maximum) {
            val.length = self.maximum;
          }
        }
      } else {
        if (Array.isArray(val)) {
          val = val[0];
        }
      }

      return val;
    },
  },
  computed: {
    canBrowse() {
      return this.browse;
    },
    referenceType() {
      return this.field.referenceType;
    },
    showList() {
      const self = this;

      if (self.field.list === false) {
        return false;
      }

      return true;
    },
    canAdd() {
      const self = this;

      if (!self.showList) {
        return true;
      }

      if (!self.maximum) {
        return true;
      }
      return self.multiValue ? self.model.length < self.maximum : !self.model;
    },
    canCreate() {
      var basicType = this.referenceType;
      if (basicType === "scope") {
        return false;
      }

      if (this.field.create === false) {
        return;
      }

      if (!this.$sdk.global?.create) {
        return;
      }

      var basicType = this.referenceType;
      var definedType = basicType;

      var match = this.$glossary.hash[this.referenceType];
      if (match) {
        basicType = match.definesType || match.key;
        definedType = match.key || match.definesType;
      }

      // Ensure the user is authenticated and they have permission to create this kind of thing
      return (
        this.user &&
        this.$sdk.access.canCreate(this.user, definedType, basicType)
      );
    },
    summary() {
      if (this.multiValue) {
        if (this.model && this.model.length) {
          var summary = `Click to select`;
          var length = this.model.length;

          if (!this.showList) {
            if (length === 1) {
              return (
                this.model[0].title ||
                this.model[0].name ||
                this.model[0].firstName
              );
            } else {
              return `${length} selected`;
            }
          }

          var difference = Math.max(length - 3, 0);
          if (length) {
            summary = `Adjust selection (${length})`;
          }

          // var cropped = this.model.slice(0, 3);
          // summary = cropped.map(function(item) {
          //     return item.firstName || item.name || item.title;
          // }).join(', ');

          // if (difference) {
          //     summary = `${summary}... +${difference} more...`
          // }

          // if(!summary) {
          //     return `Click to select`;
          // }

          return summary;
        } else {
          return `Click to select`;
        }
      } else {
        if (this.model) {
          if (this.showList) {
            return "Click to select";
          } else {
            return this.model.title || this.model.name || this.model.firstName;
          }
        } else {
          return `Click to select`;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-text-row {
  margin-bottom: 0.5em;
}

:deep(.ux-list) {
  font-size: 0.9em;
}

input {
  border-radius: 0.1em;
  padding: 0.5em;
  box-sizing: border-box;
  // background: rgba(#000, 0.05);
  // border: 1px solid rgba(#000, 0.1);
  font-size: inherit;
  appearance: none;
  line-height: 1;
  height: 2.5em;

  @extend .basic-input-style;
  &:focus {
    background: none;
    border: 1px solid var(--primary);
    outline: none;
  }
}

.ux-text-row .ux-btn {
  margin-left: 0.25em;
}

.ux-text-input-multiple {
  width: 100%;
}

.ux-text-input-single {
  width: calc(100% - 0.5em);
  margin: 0 0.5em 0 0;
}

.items {
  // border: 1px solid rgba(#000, 0.1);
  border-radius: 0.3em;
  overflow: hidden;
  margin-bottom: 0.5em;

  @media (prefers-color-scheme: light) {
    border: 1px solid color-mix(in lab, currentColor 15%, transparent);
  }

  @media (prefers-color-scheme: dark) {
    border: 1px solid color-mix(in lab, currentColor 18%, transparent);
  }

  .content-item {
    border: none;
    // border-bottom: 1px solid rgba(#000, 0.1);

    @media (prefers-color-scheme: light) {
      border-bottom: 1px solid color-mix(in lab, currentColor 15%, transparent);
    }

    @media (prefers-color-scheme: dark) {
      border-bottom: 1px solid color-mix(in lab, currentColor 18%, transparent);
    }
  }
}
</style>
